import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'utc-tooltip-content',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
})
export class TooltipContentComponent {}
